/**
 * Age Verification – JavaScript
 * ================================
 * HINWEIS: Das Schreiben des Customer-Metafields (age_verification.confirmed)
 * ist aus dem Theme-Frontend heraus NICHT möglich. Der Fetch-Hook unten
 * ist ein vorbereiteter Endpunkt, der erst funktioniert, wenn du eine
 * Shopify App oder einen App Proxy unter /apps/age-verification/confirm
 * implementiert hast.
 *
 * RECHTLICHER HINWEIS: Diese Lösung ist ein technischer UX-Schutz.
 * Für rechtssicheren Jugendschutz kann ein zertifiziertes
 * Altersverifikationssystem erforderlich sein.
 */

(function () {
  'use strict';

  // ── Hilfsfunktionen ──────────────────────────────────────────────────────

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function trapFocus(element) {
    const focusable = element.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    element.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  // ── Geschützte Inhalte verwalten ─────────────────────────────────────────

  function lockGatedContent(gatedMode) {
    // Geschützte Bilder: Placeholder anzeigen, echte URL nicht laden
    document.querySelectorAll('img.age-gated-image').forEach(function (img) {
      img.dataset.ageSrc = img.dataset.ageSrc || img.src;
      // src bleibt beim Placeholder – nichts tun
    });

    // Geschützte Abschnitte
    document.querySelectorAll('.age-gated-section').forEach(function (section) {
      if (gatedMode === 'hide') {
        section.classList.add('age-gated-section--hidden');
      } else {
        // Platzhalter einfügen
        if (!section.dataset.placeholderInserted) {
          const placeholder = document.createElement('div');
          placeholder.className = 'age-gated-placeholder';
          placeholder.textContent =
            'Dieser Inhalt wird erst nach Altersbestätigung angezeigt.';
          section.parentNode.insertBefore(placeholder, section);
          section.classList.add('age-gated-section--hidden');
          section.dataset.placeholderInserted = 'true';
          section.dataset.placeholder = placeholder;
          // Referenz speichern
          section._agePlaceholder = placeholder;
        }
      }
    });
  }

function unlockGatedContent(customerLoggedIn) {
  // Geschützte Bilder: nur freigeben wenn eingeloggt
  document.querySelectorAll('img.age-gated-image').forEach(function (img) {
    if (!img.dataset.ageSrc) return;

    if (!customerLoggedIn) {
      // Nicht eingeloggt: Placeholder bleibt, kein Blur-Fade
      // Optional: kleinen Hinweis anzeigen
      img.title = 'Bitte einloggen, um dieses Bild zu sehen.';
      return;
    }

    // Eingeloggt + bestätigt: Blur-Fade-in
    img.classList.add('age-unlocking');

    var tempImg = new Image();
    tempImg.onload = function () {
      img.src = img.dataset.ageSrc;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.classList.remove('age-unlocking');
          img.classList.add('age-unlocked');
        });
      });
    };
    tempImg.onerror = function () {
      img.src = img.dataset.ageSrc;
      img.classList.remove('age-unlocking');
    };
    tempImg.src = img.dataset.ageSrc;
  });

  // Geschützte Abschnitte: immer freigeben (unabhängig vom Login)
  document.querySelectorAll('.age-gated-section').forEach(function (section) {
    section.classList.remove('age-gated-section--hidden');
    if (section._agePlaceholder) {
      section._agePlaceholder.remove();
      section._agePlaceholder = null;
    }
  });
}



  // ── App Proxy Fetch-Hook ─────────────────────────────────────────────────
  /**
   * WICHTIG: Dieser Endpunkt (/apps/age-verification/confirm) existiert noch nicht.
   * Er muss über eine Shopify App mit App Proxy implementiert werden.
   * Die App muss dann das Customer-Metafield `age_verification.confirmed`
   * auf `true` setzen (Namespace: age_verification, Key: confirmed, Type: boolean).
   *
   * Dokumentation: https://shopify.dev/docs/apps/online-store/app-proxies
   */
  function notifyAppProxyIfLoggedIn(isLoggedIn) {
    if (!isLoggedIn) return;

    fetch('/apps/age-verification/confirm', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ confirmed: true }),
    })
      .then(function (response) {
        if (!response.ok) {
          console.warn(
            '[AgeVerification] App Proxy nicht erreichbar (HTTP ' +
              response.status +
              '). Bitte Shopify App mit App Proxy unter /apps/age-verification/confirm einrichten.'
          );
        }
      })
      .catch(function () {
        console.warn(
          '[AgeVerification] App Proxy Fetch fehlgeschlagen. ' +
            'Endpunkt /apps/age-verification/confirm ist noch nicht implementiert.'
        );
      });
  }

  // ── Hauptlogik ───────────────────────────────────────────────────────────

  function init() {
    const overlay = document.getElementById('age-verification-overlay');
    if (!overlay) return; // age_verification_enabled ist false

    const metafieldVerified = overlay.dataset.metafieldVerified === 'true';
    const customerLoggedIn = overlay.dataset.customerLoggedIn === 'true';
    const cookieName = overlay.dataset.cookieName || 'store_age_verified';
    const cookieDays = parseInt(overlay.dataset.cookieDays, 10) || 365;
    const declineUrl = overlay.dataset.declineUrl || 'https://www.google.de';
    const darkenBg = overlay.dataset.hideOverlay !== 'false';
    const gatedMode = overlay.dataset.gatedMode || 'placeholder';

    // Hintergrund-Blur deaktivieren falls gewünscht
    if (!darkenBg) {
      overlay.classList.add('age-verification-overlay--no-blur');
    }

    // 1. Metafield-Check (eingeloggter Kunde, bereits bestätigt)
    if (metafieldVerified) {
      unlockGatedContent(customerLoggedIn);
      return; // Kein Banner nötig
    }

    // 2. Cookie-Check
    const cookieValue = getCookie(cookieName);
    if (cookieValue === 'true') {
      unlockGatedContent(customerLoggedIn);
      return; // Kein Banner nötig
    }

    // 3. Inhalte sperren und Banner anzeigen
    lockGatedContent(gatedMode);
    overlay.removeAttribute('hidden');

    // Fokus auf Modal setzen
    const modal = overlay.querySelector('.age-verification-modal');
    if (modal) {
      modal.focus();
      trapFocus(modal);
    }

    // Scroll des Body verhindern
    document.body.style.overflow = 'hidden';

    // ── Bestätigen ────────────────────────────────────────────────────────
    const confirmBtn = document.getElementById('age-verification-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        // Cookie setzen
        setCookie(cookieName, 'true', cookieDays);

        // Banner ausblenden
        overlay.setAttribute('hidden', '');
        document.body.style.overflow = '';

        // Inhalte freigeben
        unlockGatedContent(customerLoggedIn);

        // App Proxy benachrichtigen (nur wenn eingeloggt)
        notifyAppProxyIfLoggedIn(customerLoggedIn);
      });
    }

    // ── Ablehnen ──────────────────────────────────────────────────────────
    const declineBtn = document.getElementById('age-verification-decline');
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        window.location.href = declineUrl;
      });
    }

    // ── ESC-Taste: Ablehnen (Weiterleitung) ───────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) {
        window.location.href = declineUrl;
      }
    });
  }

  // DOM bereit
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
